import { write } from "lib/storage";
import { Locale } from "models/locale";
import { useStore } from "stores/store";

export const changeLocale = async (locale: Locale) => {
  // change only the generic locale state, admin/user state should be fetched seperately
  useStore.setState((state) => ({ ...state, locale }));

  // persist to localStorage
  write<Locale>("locale", locale);
};
